import * as actions from '..';

const summaryReducerDefaultState = {
  defaultPaymentMethod: {},
  nextivaPlan: {},
  contactInfo: {
    account_manager: {
      contact: {
        first_name: '',
        last_name: '',
      },
    },
  },
  bill: {},
  paymentType: {},
  isPaymentDisabled: true,
  isPaymentMethodCapabilityEnabled: false,
};

export const summaryReducer = (state = summaryReducerDefaultState, action) => {
  switch (action.type) {
    case actions.ADD_DEFAULT_PAYMENT_METHOD:
      return {
        ...state,
        defaultPaymentMethod: {
          ...action.payload,
        },
      };
    case actions.ADD_NEXTIVA_PLAN:
      return {
        ...state,
        nextivaPlan: {
          ...action.payload,
        },
      };
    case actions.ADD_CONTACT_INFO:
      return {
        ...state,
        contactInfo: {
          ...action.payload,
        },
      };
    case actions.ADD_NEXTIVA_BILL:
      return {
        ...state,
        bill: {
          ...action.payload,
        },
      };
    case actions.ADD_PAYMENT_TYPE_OBJECT:
      return {
        ...state,
        paymentType: {
          ...action.payload,
        },
      };
    case actions.PROCESS_NEXTIVA_BILL:
    case actions.CLEAR_PAYMENT_TYPE_OBJECT:
      return {
        ...state,
        paymentType: {},
      };
    case actions.SET_PAYMENT_DISABLED:
      return {
        ...state,
        isPaymentDisabled: action.payload,
      };
    case actions.SET_PAYMENT_METHOD_CAPABILITY_ENABLED:
      return {
        ...state,
        isPaymentMethodCapabilityEnabled: action.payload,
      };
    case actions.CLEAR_NEXTIVA_BILL:
      return {
        ...state,
        bill: {},
      };
    case actions.CLEAR_NEXTIVA_PLAN:
      return {
        ...state,
        nextivaPlan: {},
      };
    case actions.CLEAR_DEFAULT_PAYMENT_METHOD:
      return {
        ...state,
        defaultPaymentMethod: {},
      };
    default:
      return state;
  }
};
